import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { Icon } from '../../../../../CommonComponents/OPL/Icon/Icon';
import { Toggle } from '../../../../../CommonComponents/OPL/Toggle/Toggle';
import { Tooltip } from '../../../../../CommonComponents/OPL/Tooltip/Tooltip';
import { MarginProps } from '../../../../../theme/styledProps';
import { useFeatureFlag } from '../../../../../_hooks/useFeatureFlag';
import { Feature } from '../../../../../CommonSelectors/CommonArea.types';
import { FormValues } from '../../FirmSettings.meta';
import { SectionHeader } from '../SectionHeader/SectionHeader';
import { TOOLTIP_TEXT } from './DocumentVault.meta';

interface Props extends MarginProps {
  formBag: UseFormReturn<FormValues>;
}

export const DocumentVault = ({ formBag, ...rest }: Props) => {
  const showThirdPartySharing = useFeatureFlag(Feature.EnableThirdPartyDocumentVaultSharing);

  if (!showThirdPartySharing) {
    return null;
  }

  return (
    <Box as="section" {...rest}>
      <SectionHeader title="Document Vault" />

      <Box display="flex" alignItems="center" mt="24">
        <Toggle {...formBag.register('enableThirdPartySharing')}>
          Enable Third-Party Document Sharing
        </Toggle>

        <Tooltip content={TOOLTIP_TEXT}>
          <Icon className="far fa-info-circle" color="neutral.500" fontSize="small" ml="4" />
        </Tooltip>
      </Box>
    </Box>
  );
};
